import { render, staticRenderFns } from "./EmailDeliveryTable.vue?vue&type=template&id=075046a0"
import script from "./EmailDeliveryTable.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryTable.vue?vue&type=script&lang=js"
import style0 from "./EmailDeliveryTable.vue?vue&type=style&index=0&id=075046a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports